export default function About() {
  return (
    <div className="container mx-auto px-4 py-12 max-w-3xl">
      <h1 className="text-4xl font-bold text-primary mb-8">关于</h1>

      <div className="space-y-6 text-secondary">
        <p>
          LPL 选手追踪器是一个非官方项目，旨在记录和展示那些在 2025 年活跃，
          但在 2026 年消失在赛场上的 LPL 职业选手。
        </p>

        <h2 className="text-2xl font-semibold text-primary mt-8 mb-4">数据来源</h2>
        <ul className="list-disc list-inside space-y-2 text-tertiary">
          <li>LPL 官方网站</li>
          <li>LoL Fandom Wiki</li>
          <li>Riot Games Esports API</li>
        </ul>

        <h2 className="text-2xl font-semibold text-primary mt-8 mb-4">技术栈</h2>
        <ul className="list-disc list-inside space-y-2 text-tertiary">
          <li>前端: React + TypeScript + Tailwind CSS</li>
          <li>后端: Cloudflare Workers + D1</li>
          <li>部署: Cloudflare Pages</li>
        </ul>

        <h2 className="text-2xl font-semibold text-primary mt-8 mb-4">声明</h2>
        <p className="text-tertiary">
          本项目为非营利性项目，所有选手照片、战队标志等版权归原作者所有。
          如有侵权，请联系删除。
        </p>
      </div>
    </div>
  )
}
